const createHslColorString = ({ h, s, l }) =>
  `hsl(${parseInt(h, 10)}, ${parseInt(s * 100, 10)}%, ${parseInt(l * 100, 10)}%)`;

export default createHslColorString;
